import React, { useContext } from 'react'
import {
    StyleButtonWrapper,
    StyledActionGroup,
    StyledDeleteAccount,
} from './DeleteAccount.styled'
import { WebLink } from '@news-mono/web-common'
import { TNLink } from '../components/TNLink'
import { tokens } from '@news-mono/design-tokens'
import { TNButton } from '../components/TNButton'
import { MyAccountContext } from '../hooks/useMyAccountContext'

const { utility } = tokens.thenightly.colors.palette

export const DeleteAccount = () => {
    const { setScreen, setScreenSelected } = useContext(MyAccountContext)

    return (
        <StyledDeleteAccount>
            <p>
                Deleting your account with The Nightly will only delete the
                personal and other information you provided to us when you
                registered or updated this account such as your username, name
                and email address.
            </p>
            <p>
                Please note this does not extend to other accounts that you have
                registered or information you have shared with Seven West Media
                including when entering into a competition, or posting comments
                on our websites or social media pages/channels including on The
                Nightly, or in correspondence. For more information please see
                our{' '}
                <WebLink
                    to={
                        'https://www.sevenwestmedia.com.au/privacy-policies/privacy'
                    }
                >
                    Privacy Policy
                </WebLink>
                .
            </p>
            <StyledActionGroup>
                <TNLink
                    color={utility.error.default}
                    onClick={() => setScreen('delete-account-acknowledge')}
                    disabled={false}
                    fontWeight={600}
                    underline={false}
                >
                    DELETE MY ACCOUNT
                </TNLink>
                <StyleButtonWrapper>
                    <TNButton
                        onClick={() => {
                            setScreen('manage-account')
                            setScreenSelected(true)
                        }}
                        btnType="primary"
                        disabled={false}
                    >
                        CANCEL
                    </TNButton>
                </StyleButtonWrapper>
            </StyledActionGroup>
        </StyledDeleteAccount>
    )
}
